export default "__VITE_ASSET__DOrwxEdK__"